export const dealerSignup = {
    // type: "personal details",
    _id: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dealerDOB: "",
    ssn: "",
    homeAddressLine1: "",
    homeCity: "",
    homeState: "",
    homeZipCode: "",
    dealerName: "",
    requestedFacilityAmount: "",
    dealerAddressLine1: "",
    dealerCity: "",
    dealerState: "",
    dealerZipCode: "",
    password: "",
    confirmPassword: "",
    termsAndConditionsAccepted: false
}

export const dealerSignupS1 = {
    type: "personal details",
    _id: "",
    firstName: "",
    lastName: "",
    dealerName: "",
    email: "",
    password: "",
    confirmPassword: ""
}

export const dealerSignupS2 = {
    type: "address details",
    _id: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    ssn: "",
    requestedFacilityAmount: "",
    homeAddressLine1: "",
    homeAddressLine2: "",
    homeCity: "",
    homeState: "",
    homeZipCode: "",
    termsAndConditionsAccepted: false
}
export const principalInformation = {
    _id: '',
    selectedTab: 1,
    dealerPrincipal: []
}

export const financialDetails = {
    _id: "",
    selectedTab: 2
}

export const dealershipInfoS1 = {
    _id: "",
    selectedTab: 3,
    numberOfLocations: "",
    avgUnitsSoldPerMonth: "",
    avgInventoryAge: "",
    avgSalePrice: "",
    yearsInBusiness: "",
    webAddress: "",
    auctionAccessNumber: ""
}

export const dealershipInfoS2 = {
    _id: "",
    selectedTab: 4,
    buildingOwned: false,
    leasingCompany: "",
    leaseContactName: "",
    leaseContactPhoneNumber: "",
    leaseEndDate: ""
}

export const dealershipInfoS3 = {
    _id: "",
    selectedTab: 5,
    commercialInsuranceName: "",
    commercialInsuranceEmail: "",
    commercialInsurancePhone: "",
    currentFloorPlanCompaniesUsed: [],
    currentRetailFinanceUsed: [],
    productCompaniesUsed: []
}


export const attachments = {
    _id: "",
    selectedTab: 6,
    dealersLicense: { docs: [], isMultiple: false, label: 'Dealers License' },
    businessLicense: { docs: [], isMultiple: false, label: 'Business License' },
    driversLicense: { docs: [], isMultiple: true, label: "Driver's License (for all Dealer Principal(s) with more than 10% ownership)" },
    dealershipInsurance: { docs: [], isMultiple: false, label: 'Copy of Dealership Insurance' },
    dealerBond: { docs: [], isMultiple: false, label: 'Copy of Dealer Bond' },
    bankStatements: { docs: [], isMultiple: true, label: '6 Months Bank Statements' },
    floorPlanRecievables: { docs: [], isMultiple: true, label: 'Floor Plan Receivables' },
    lotPhoto: { docs: [], isMultiple: true, label: 'Lot Photo' },
    voidedCheck: { docs: [], isMultiple: true, label: 'Voided Check' },
    personalGuarantorTaxReturn: { docs: [], isMultiple: true, label: '2 years personal tax return' },
    businessTaxReturns: { docs: [], isMultiple: true, label: '2 years business tax return' }
}

export const newAttachments = {
    _id: "",
    selectedTab: 6,
    dealersLicense: { docs: [], isMultiple: true, label: 'Dealership License' },
    businessLicense: { docs: [], isMultiple: true, label: 'Business License' },
    driversLicense: { docs: [], isMultiple: true, label: "Driver's License (for all Dealer Principals)" },
    dealershipInsurance: { docs: [], isMultiple: true, label: 'Dealership Insurance' },
    dealerBond: { docs: [], isMultiple: true, label: 'Dealer Bond' },
    bankStatements: { docs: [], isMultiple: true, label: '3 Months Bank Statements' },
    floorPlanRecievables: { docs: [], isMultiple: true, label: 'All Current Floorplan Receivable Reports' },
    lotPhoto: { docs: [], isMultiple: true, label: 'Lot Photo' },
    voidedCheck: { docs: [], isMultiple: true, label: 'Voided Check' },
    personalGuarantorTaxReturn: { docs: [], isMultiple: true, label: '2 years personal tax return' },
    businessTaxReturns: { docs: [], isMultiple: true, label: '2 years business tax return' },
    financialYears: { docs: [], isMultiple: true, label: '2 years financials' },
    ytdFinancialStatements : { docs: [], isMultiple: true, label: 'YTD financial statements' },
    additionalDocs: { docs: [], isMultiple: true, label: 'Additional documents' }
}

export const digitalSignature = {
    _id: "",
    selectedTab: 7,
    name: "",
    title: "",
    onBoardFormSubmitted: false,
    digitalSignature: {
        "fileName": "",
        "base64Image": "",
        "fileType": ""
    },
    onBoardingPdf: {
        "fileName": "",
        "base64Image": "",
        "fileType": ""
    }
}